export type TableRequestState =
  | { status: 'loading'; error: null }
  | { status: 'refreshing'; error: null }
  | { status: 'success'; error: null }
  | { status: 'error'; error: string; hasStaleData: boolean };

export const initialTableRequestState: TableRequestState = {
  status: 'loading',
  error: null,
};

export const successfulTableRequestState: TableRequestState = {
  status: 'success',
  error: null,
};
